import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { z } from 'zod'
import { ReservationStatusSchema } from '../sale1010/list.schema'

dayjs.extend(isoWeek)

export const Sale1020SearchParamsSchema = z
  .object({
    partyId: z.string().optional(),
    date: z.coerce.date().default(new Date()),
    itemType: z.string().optional(),
  })
  .transform((data) => {
    return {
      date: data.date,
      partyId: data.partyId,
      itemType: data.itemType ?? undefined,
      year: dayjs(data.date).isoWeekYear(),
      weekNumber: dayjs(data.date).isoWeek(),
    }
  })

export type Sale1020SearchParams = z.infer<typeof Sale1020SearchParamsSchema>

export const Sale1020ItemSlotSchema = z.object({
  saleOrderId: z.number(),
  saleOrderNumber: z.string(),
  qty: z.number(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  reservationStatus: ReservationStatusSchema.optional(),
})
export type Sale1020ItemSlot = z.infer<typeof Sale1020ItemSlotSchema>

export const Sale1020TimeSlotSchema = z.object({
  items: z.array(Sale1020ItemSlotSchema),
  totalQty: z.number(),
})
export type Sale1020TimeSlot = z.infer<typeof Sale1020TimeSlotSchema>

export const Sale1020DaySlotSchema = z.object({
  dayOfWeek: z.number(),
  date: z.coerce.date(),
  morning: Sale1020TimeSlotSchema.nullable(),
  afternoon: Sale1020TimeSlotSchema.nullable(),
  night: Sale1020TimeSlotSchema.nullable(),
})
export type Sale1020DaySlot = z.infer<typeof Sale1020DaySlotSchema>

export const Sale1020ItemSchema = z.object({
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  customerItemCode: z.string(),
  customerItemName: z.string(),
  partyId: z.number(),
  partyCode: z.string(),
  partyName: z.string(),
  daySlots: z.array(Sale1020DaySlotSchema),
})
export type Sale1020Item = z.infer<typeof Sale1020ItemSchema>

export const Sale1020SearchResultSchema = z.object({
  year: z.number(),
  weekNumber: z.number(),
  weekStartDate: z.coerce.date(),
  items: z.array(Sale1020ItemSchema),
  gridId: z.string().optional(),
})
export type Sale1020SearchResult = z.infer<typeof Sale1020SearchResultSchema>

export const Sale1020RowTimeSlotSchema = z.object({
  dayOfWeek: z.number(),
  date: z.coerce.date(),
  timeShift: z.enum(['morning', 'afternoon', 'night']),
  slot: Sale1020TimeSlotSchema.nullable(),
})
export type Sale1020RowTimeSlot = z.infer<typeof Sale1020RowTimeSlotSchema>

export const Sale1020RowModelSchema = z.object({
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  customerItemCode: z.string(),
  customerItemName: z.string(),
  partyId: z.number(),
  partyCode: z.string(),
  partyName: z.string(),
  day1Morning: Sale1020RowTimeSlotSchema,
  day1Afternoon: Sale1020RowTimeSlotSchema,
  day1Night: Sale1020RowTimeSlotSchema,
  day2Morning: Sale1020RowTimeSlotSchema,
  day2Afternoon: Sale1020RowTimeSlotSchema,
  day2Night: Sale1020RowTimeSlotSchema,
  day3Morning: Sale1020RowTimeSlotSchema,
  day3Afternoon: Sale1020RowTimeSlotSchema,
  day3Night: Sale1020RowTimeSlotSchema,
  day4Morning: Sale1020RowTimeSlotSchema,
  day4Afternoon: Sale1020RowTimeSlotSchema,
  day4Night: Sale1020RowTimeSlotSchema,
  day5Morning: Sale1020RowTimeSlotSchema,
  day5Afternoon: Sale1020RowTimeSlotSchema,
  day5Night: Sale1020RowTimeSlotSchema,
  day6Morning: Sale1020RowTimeSlotSchema,
  day6Afternoon: Sale1020RowTimeSlotSchema,
  day6Night: Sale1020RowTimeSlotSchema,
})
export type Sale1020RowModel = z.infer<typeof Sale1020RowModelSchema>
